<template>
  <div>
    <h2>{{ $t('title.switches') }}</h2>

    <data-table
      :model="switches"
      :columns="['controllerName', 'name']"
      :operations="operations"
      :custom-sort="sort"
    />

  </div>

</template>

<script>
import findAll from 'service/findAll'

import { SWITCH_EDIT, SINGLE_SWITCH_ACCESS } from 'router/routes'
import { post } from 'providers/http'

export default {
  name: 'switch-list',
  methods: {
    sort (first, second) {
      const comp = first.controllerName.localeCompare(second.controllerName)

      if (comp !== 0) {
        return comp
      }

      return first.name.localeCompare(second.name)
    }
  },
  computed: {
    operations () {
      return [
        {
          label: 'edit',
          icon: 'edit',
          permission: ['EDIT_SWITCH', 'server_id'],
          method: (swithc) => this.$router.push({ name: SWITCH_EDIT, params: { 'id': swithc.id } })
        },
        {
          label: 'single-access',
          type: 'success',
          icon: 'circle-check',
          permission: ['VIEW_SINGLE_MOBILE_ACCESSES', 'server_id'],
          method: (swithc) => this.$router.push({ name: SINGLE_SWITCH_ACCESS, params: { 'id': swithc.id } })
        },
        {
          label: 'off',
          type: 'danger',
          icon: 'circle-close',
          permission: ['TOGGLE_SWITCH', 'server_id'],
          method: (swithc) => post(`api/v1/toggle/${swithc.id}`, { state: 1 })
        },
        {
          label: 'on',
          type: 'success',
          icon: 'caret-right',
          permission: ['TOGGLE_SWITCH', 'server_id'],
          method: (swithc) => post(`api/v1/toggle/${swithc.id}`, { state: 2 })
        },
        {
          label: 'toggle',
          type: 'success',
          icon: 'time',
          permission: ['TOGGLE_SWITCH', 'server_id'],
          method: (swithc) => post(`api/v1/toggle/${swithc.id}`, { state: 3 })
        }
      ]
    }
  },
  mixins: [
    findAll('switches', {
      filter ({ usage }) { return usage === 'entry-point' || usage === 'system' }
    })
  ]
}
</script>


// WEBPACK FOOTER //
// SwitchList.vue?ba39004e